<template>
  <div id="dashboard-greeting">
    <h2>Hello {{ name }}</h2>
  </div>
</template>

<script>
export default {
  props: ['name']
}
</script>

<style>
  #dashboard-greeting {
    margin-left: 1em;
  }
</style>
